import React from 'react';
import ErrorPage from '../../views/Error.jsx';
import './SecurityCheck.scss';

export const SecurityCheck = () => {
	return (
		<div data-testid="security-check">
			<div className="SecurityCheckContainer">
				<ErrorPage />
			</div>
		</div>
	);
};

export default SecurityCheck;
